const sizes = {
  sm: { icon: 28, text: 'text-lg', tagline: 'text-[8px]' },
  md: { icon: 36, text: 'text-2xl', tagline: 'text-[9px]' },
  lg: { icon: 52, text: 'text-4xl', tagline: 'text-xs' },
};

export function LogoMark({ size = 36, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className={className}>
      <defs>
        <linearGradient id="msmeCore" x1="36" y1="36" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#22D3EE" />
        </linearGradient>
      </defs>
      <g fill="#0B1B33">
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(0 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(45 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(90 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(135 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(180 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(225 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(270 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(315 50 50)" />
      </g>
      <circle cx="50" cy="50" r="34" fill="#0B1B33" />
      <circle cx="50" cy="50" r="22" fill="none" stroke="#64748B" strokeWidth="8" />
      <circle cx="50" cy="50" r="14" fill="url(#msmeCore)" />
    </svg>
  );
}

export function Logo({ size = 'md', showTagline = false, className = '' }) {
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={s.icon} className="shrink-0" />
      <div className="flex flex-col leading-none">
        <span className={`font-black tracking-tight ${s.text}`} style={{ fontFamily: "'Outfit', sans-serif" }}>
          <span className="text-slate-900 dark:text-white">MSME </span>
          <span className="bg-gradient-to-r from-blue-600 to-cyan-400 bg-clip-text text-transparent tracking-wide">Center</span>
        </span>
        {showTagline && (
          <span className={`${s.tagline} font-semibold uppercase tracking-widest text-slate-600 dark:text-slate-400 mt-1`}>
            Empowering Businesses. Enabling Growth.
          </span>
        )}
      </div>
    </div>
  );
}
